import { RootState } from "../storeConfig";
import { IPayloadWrapper } from "../types/PayloadWrapper";

export const SET_IS_SWAP_BOX_MODAL_OPEN =
  "automatpacken/controlAppState/SET_IS_SWAP_BOX_MODAL_OPEN";
export const SET_IS_VERIFY_PICK_MODAL_OPEN =
  "automatpacken/controlAppState/SET_IS_VERIFY_PICK_MODAL_OPEN";
export const SET_IS_CHANGE_WEIGHT_MODAL_OPEN =
  "automatpacken/controlAppState/SET_IS_CHANGE_WEIGHT_MODAL_OPEN";
export const SET_IS_PARTIAL_DELIVERY_MODAL_OPEN =
  "automatpacken/controlAppState/SET_IS_PARTIAL_DELIVERY_MODAL_OPEN";
export const SET_IS_BOX_SWAP_FINISHED = "automatpacken/controlAppState/SET_IS_BOX_SWAP_FINISHED";
export const SET_PICK_ACTION_TAKEN = "automatpacken/controlAppState/SET_PICK_ACTION_TAKEN";
export const CLEAR_APP_STATE = "automatpacken/controlAppState/CLEAR_APP_STATE";
export const ADD_PREVIOUS_HANDLED_BOX = "automatpacken/controlAppState/ADD_PREVIOUS_HANDLED_BOX";
export const SET_IS_SCAN_DISABLED = "automatpacken/controlAppState/SET_IS_SCAN_DISABLED";
export const SET_IS_FORCED_RX_BAG_VERIFICATION =
  "automatpacken/controlAppState/SET_IS_FORCED_RX_BAG_VERIFICATION";
export const SET_IS_FORCED_RX_BAG_VERIFICATION_FINISHED =
  "automatpacken/controlAppState/SET_IS_FORCED_RX_BAG_VERIFICATION_FINISHED";
export const RESET_CURRENT_APP_STATE = "automatpacken/controlAppState/RESET_CURRENT_APP_STATE";

interface ClearAppState {
  type: typeof CLEAR_APP_STATE;
}

interface setIsSwapBoxModalOpen {
  type: typeof SET_IS_SWAP_BOX_MODAL_OPEN;
  payload: IPayloadWrapper<boolean>;
}

interface setIsVerifyPickModalOpen {
  type: typeof SET_IS_VERIFY_PICK_MODAL_OPEN;
  payload: IPayloadWrapper<boolean>;
}
interface setIsChangeWeightModalOpen {
  type: typeof SET_IS_CHANGE_WEIGHT_MODAL_OPEN;
  payload: IPayloadWrapper<boolean>;
}

interface setIsPartialDeliveryModalOpen {
  type: typeof SET_IS_PARTIAL_DELIVERY_MODAL_OPEN;
  payload: IPayloadWrapper<boolean>;
}

interface setIsBoxSwapFinished {
  type: typeof SET_IS_BOX_SWAP_FINISHED;
  payload: IPayloadWrapper<boolean>;
}

interface setIsForcedRxBagVerificationFinished {
  type: typeof SET_IS_FORCED_RX_BAG_VERIFICATION_FINISHED;
  payload: IPayloadWrapper<boolean>;
}

interface setPickActionTaken {
  type: typeof SET_PICK_ACTION_TAKEN;
  payload: IPayloadWrapper<boolean>;
}
interface addPreviousHandledBox {
  type: typeof ADD_PREVIOUS_HANDLED_BOX;
  payload: IPayloadWrapper<string>;
}

interface setIsScanDisabled {
  type: typeof SET_IS_SCAN_DISABLED;
  payload: IPayloadWrapper<boolean>;
}
interface setIsForcedRxBagVerification {
  type: typeof SET_IS_FORCED_RX_BAG_VERIFICATION;
  payload: IPayloadWrapper<boolean>;
}

interface setIsForcedRxBagVerificationFinished {
  type: typeof SET_IS_FORCED_RX_BAG_VERIFICATION_FINISHED;
  payload: IPayloadWrapper<boolean>;
}

interface resetCurrentAppState {
  type: typeof RESET_CURRENT_APP_STATE;
}

type ControlAppStateTypes =
  | setIsPartialDeliveryModalOpen
  | setIsBoxSwapFinished
  | setIsForcedRxBagVerificationFinished
  | setPickActionTaken
  | ClearAppState
  | setIsSwapBoxModalOpen
  | addPreviousHandledBox
  | setIsChangeWeightModalOpen
  | setIsVerifyPickModalOpen
  | setIsScanDisabled
  | setIsForcedRxBagVerification
  | resetCurrentAppState;

export const clearAppState = (): ControlAppStateTypes => {
  return {
    type: CLEAR_APP_STATE,
  };
};
export const setIsSwapBoxModalOpen = (payload: IPayloadWrapper<boolean>): ControlAppStateTypes => {
  return {
    type: SET_IS_SWAP_BOX_MODAL_OPEN,
    payload,
  };
};
export const setIsVerifyPickModalOpen = (
  payload: IPayloadWrapper<boolean>
): ControlAppStateTypes => {
  return {
    type: SET_IS_VERIFY_PICK_MODAL_OPEN,
    payload,
  };
};
export const setIsChangeWeightModalOpen = (
  payload: IPayloadWrapper<boolean>
): ControlAppStateTypes => {
  return {
    type: SET_IS_CHANGE_WEIGHT_MODAL_OPEN,
    payload,
  };
};

export const setIsPartialDeliveryModalOpen = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_IS_PARTIAL_DELIVERY_MODAL_OPEN,
    payload,
  };
};

export const setIsForcedRxBagVerification = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_IS_FORCED_RX_BAG_VERIFICATION,
    payload,
  };
};

export const setIsForcedRxBagVerificationFinished = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_IS_FORCED_RX_BAG_VERIFICATION_FINISHED,
    payload,
  };
};

export const setIsBoxSwapFinished = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_IS_BOX_SWAP_FINISHED,
    payload,
  };
};

export const setPickActionTaken = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_PICK_ACTION_TAKEN,
    payload,
  };
};

export const addPreviousHandledBox = (payload: IPayloadWrapper<string>) => {
  return {
    type: ADD_PREVIOUS_HANDLED_BOX,
    payload,
  };
};

export const setIsScanDisabled = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_IS_SCAN_DISABLED,
    payload,
  };
};

export const resetCurrentAppState = () => {
  return {
    type: RESET_CURRENT_APP_STATE,
  };
};

type InitialControlAppStateTypes = {
  isSwapBoxModalOpen: boolean;
  isVerifyPickModalOpen: boolean;
  isChangeWeightModalOpen: boolean;
  isPartialDeliveryModalOpen: boolean;
  isBoxSwapFinished: boolean;
  isForcedRxBagVerification: boolean;
  isForcedRxBagVerificationFinished: boolean;
  pickActionTaken: boolean;
  previouslyHandledBoxes: string[];
  isScanDisabled: boolean;
};
export const initialControlAppState: InitialControlAppStateTypes = {
  isSwapBoxModalOpen: false,
  isVerifyPickModalOpen: false,
  isChangeWeightModalOpen: false,
  isPartialDeliveryModalOpen: false,
  isBoxSwapFinished: false,
  isForcedRxBagVerification: false,
  isForcedRxBagVerificationFinished: false,
  pickActionTaken: false,
  previouslyHandledBoxes: [],
  isScanDisabled: false,
};

/**
 * -------------------------------------
 * Reducer definition
 * -------------------------------------
 * */
const controlAppStateReducer = (
  state = initialControlAppState,
  action: ControlAppStateTypes
): InitialControlAppStateTypes => {
  switch (action.type) {
    case SET_IS_SWAP_BOX_MODAL_OPEN:
      return { ...state, isSwapBoxModalOpen: action.payload.value };
    case SET_IS_VERIFY_PICK_MODAL_OPEN:
      return { ...state, isVerifyPickModalOpen: action.payload.value };
    case SET_IS_CHANGE_WEIGHT_MODAL_OPEN:
      return { ...state, isChangeWeightModalOpen: action.payload.value };
    case SET_IS_PARTIAL_DELIVERY_MODAL_OPEN:
      return { ...state, isPartialDeliveryModalOpen: action.payload.value };
    case SET_IS_BOX_SWAP_FINISHED:
      return { ...state, isBoxSwapFinished: action.payload.value };
    case SET_IS_FORCED_RX_BAG_VERIFICATION_FINISHED:
      return { ...state, isForcedRxBagVerificationFinished: action.payload.value };
    case SET_PICK_ACTION_TAKEN:
      return { ...state, pickActionTaken: action.payload.value };
    case SET_IS_SCAN_DISABLED:
      return { ...state, isScanDisabled: action.payload.value };
    case SET_IS_FORCED_RX_BAG_VERIFICATION:
      return { ...state, isForcedRxBagVerification: action.payload.value };
    case ADD_PREVIOUS_HANDLED_BOX:
      return {
        ...state,
        previouslyHandledBoxes: [action.payload.value, ...state.previouslyHandledBoxes],
      };
    case RESET_CURRENT_APP_STATE:
      return { ...initialControlAppState };
    default:
      return state;
  }
};

// SELECTOR HELPERS
const controlAppStateSelector = (state: RootState) => state.controlAppStateReducer;

/**
 * -------------------------------------
 * Public interface
 * -------------------------------------
 * */
export { controlAppStateReducer, controlAppStateSelector };
